import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Upload, X } from "lucide-react";
import * as XLSX from 'xlsx';
import ExcelTemplate from "./ExcelTemplate";

export default function AddandEditform ({visible, setVisible, formdata, handlesave, handleupdate, handlechange}) {
    const [maximized, setMaximized] = useState(true);
    const [diagramFiles, setDiagramFiles] = useState({});
    const [optionImageFiles, setOptionImageFiles] = useState({});

    const calculateSalePrice = (regularPrice, discount) => {
        const price = parseFloat(regularPrice) || 0;
        const discountRate = parseFloat(discount) || 0;
        return Math.round(price - (price * (discountRate / 100)));
    };

    const handleDiagramChange = (e, testIndex, questionIndex) => {
        const file = e.target.files[0];
        if (!file) return;

        const key = `${testIndex}-${questionIndex}`;
        const updatedDiagramFiles = { ...diagramFiles, [key]: file };
        setDiagramFiles(updatedDiagramFiles);

        updateQuestion(testIndex, questionIndex, 'diagram', file);
    };

    const removeDiagram = (testIndex, questionIndex) => {
        const key = `${testIndex}-${questionIndex}`;
        const updatedDiagramFiles = { ...diagramFiles };
        delete updatedDiagramFiles[key];
        setDiagramFiles(updatedDiagramFiles);

        updateQuestion(testIndex, questionIndex, 'diagram', '');
        updateQuestion(testIndex, questionIndex, 'question_type', 'text');
    };

    const handleOptionImageChange = (e, testIndex, questionIndex, optionIndex) => {
        const file = e.target.files[0];
        if (!file) return;

        const key = `${testIndex}-${questionIndex}-${optionIndex}`;
        const updatedOptionImageFiles = { ...optionImageFiles, [key]: file };
        setOptionImageFiles(updatedOptionImageFiles);

        updateQuestionOptionImage(testIndex, questionIndex, optionIndex, file);
        updateQuestionOption(testIndex, questionIndex, optionIndex, '');
    };

    const removeOptionImage = (testIndex, questionIndex, optionIndex) => {
        const key = `${testIndex}-${questionIndex}-${optionIndex}`;
        const updatedOptionImageFiles = { ...optionImageFiles };
        delete updatedOptionImageFiles[key];
        setOptionImageFiles(updatedOptionImageFiles);
        updateQuestionOptionImage(testIndex, questionIndex, optionIndex, '');
        updateQuestionOption(testIndex, questionIndex, optionIndex, '');
    };

    const updateQuestionOptionImage = (testIndex, questionIndex, optionIndex, value) => {
        const updatedTests = [...formdata.tests];
        if (!updatedTests[testIndex].questions[questionIndex].option_images) {
            updatedTests[testIndex].questions[questionIndex].option_images = ['', '', '', ''];
        }
        updatedTests[testIndex].questions[questionIndex].option_images[optionIndex] = value;
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    useEffect(() => {
        if (formdata.Price && formdata.Discount) {
            const salePrice = calculateSalePrice(formdata.Price, formdata.Discount);
            handlechange({ target: { name: 'Sale_Price', value: salePrice }});
        }
    }, [formdata.Price, formdata.Discount]);

    const handleQuillChange = (value) => {
        handlechange({
            target: {
                name: 'Description',
                value: value,
            },
        });
    };

    const addTest = () => {
        const newTest = {
            test_name: '',
            duration: '',
            total_marks: '',
            negative_marking: false,
            marks_per_question: '',
            negative_marks: '',
            has_subjects: false,
            subjects: [],
            questions: []
        };
        
        const updatedTests = [...(formdata.tests || []), newTest];
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const removeTest = (testIndex) => {
        const updatedTests = formdata.tests.filter((_, idx) => idx !== testIndex);
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const updateTest = (testIndex, field, value) => {
        const updatedTests = [...formdata.tests];
        updatedTests[testIndex] = { ...updatedTests[testIndex], [field]: value };
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const addSubject = (testIndex) => {
        const updatedTests = [...formdata.tests];
        const newSubject = {
            subject_name: '',
            question_count: 0
        };
        updatedTests[testIndex].subjects = [...(updatedTests[testIndex].subjects || []), newSubject];
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const removeSubject = (testIndex, subjectIndex) => {
        const updatedTests = [...formdata.tests];
        updatedTests[testIndex].subjects = updatedTests[testIndex].subjects.filter((_, idx) => idx !== subjectIndex);
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const updateSubject = (testIndex, subjectIndex, field, value) => {
        const updatedTests = [...formdata.tests];
        updatedTests[testIndex].subjects[subjectIndex] = {
            ...updatedTests[testIndex].subjects[subjectIndex],
            [field]: value
        };
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const addQuestion = (testIndex, subjectName = null) => {
        const updatedTests = [...formdata.tests];
        const newQuestion = {
            question_text: '',
            question_type: 'text',
             diagram: '',
            options: ['', '', '', ''],
            option_images: ['', '', '', ''],
            correct_answer: '',
            explanation: '',
            subject: subjectName
        };
        updatedTests[testIndex].questions = [...(updatedTests[testIndex].questions || []), newQuestion];
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const removeQuestion = (testIndex, questionIndex) => {
        const updatedTests = [...formdata.tests];
        updatedTests[testIndex].questions = updatedTests[testIndex].questions.filter((_, idx) => idx !== questionIndex);
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const updateQuestion = (testIndex, questionIndex, field, value) => {
        const updatedTests = [...formdata.tests];
        updatedTests[testIndex].questions[questionIndex] = {
            ...updatedTests[testIndex].questions[questionIndex],
            [field]: value
        };
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const updateQuestionOption = (testIndex, questionIndex, optionIndex, value) => {
        const updatedTests = [...formdata.tests];
        const options = [...updatedTests[testIndex].questions[questionIndex].options];
        options[optionIndex] = value;
        updatedTests[testIndex].questions[questionIndex].options = options;
        
        if (!updatedTests[testIndex].questions[questionIndex].option_images) {
            updatedTests[testIndex].questions[questionIndex].option_images = ['', '', '', ''];
        }
        
        handlechange({ target: { name: 'tests', value: updatedTests }});
    };

    const normalizeCorrectAnswer = (answer) => {
        if (!answer) return '';
        
        const answerStr = String(answer).trim().toLowerCase();
        
        if (/^option_[0-3]$/.test(answerStr)) {
            return answerStr;
        }
        
        const letterMap = { 'a': 'option_0', 'b': 'option_1', 'c': 'option_2', 'd': 'option_3' };
        if (letterMap[answerStr]) {
            return letterMap[answerStr];
        }
        
        const numberMap = { '1': 'option_0', '2': 'option_1', '3': 'option_2', '4': 'option_3' };
        if (numberMap[answerStr]) {
            return numberMap[answerStr];
        }
        
        if (answerStr.includes('option')) {
            const match = answerStr.match(/option\s*([1-4a-d])/i);
            if (match) {
                const value = match[1].toLowerCase();
                if (numberMap[value]) return numberMap[value];
                if (letterMap[value]) return letterMap[value];
            }
        }
        
        return '';
    };

    const handleBulkUpload = (e, testIndex) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const workbook = XLSX.read(event.target.result, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const data = XLSX.utils.sheet_to_json(sheet);

                if (data.length === 0) {
                    alert('Excel file is empty!');
                    e.target.value = '';
                    return;
                }

                const updatedTests = [...formdata.tests];
                
                const questions = data.map(row => {
                    const optionImages = [
                        row['Option 1 Image'] || row['option_1_image'] || '',
                        row['Option 2 Image'] || row['option_2_image'] || '',
                        row['Option 3 Image'] || row['option_3_image'] || '',
                        row['Option 4 Image'] || row['option_4_image'] || ''
                    ];
                    
                    const options = [
                        optionImages[0] ? '' : (row['Option 1'] || row['option_1'] || ''),
                        optionImages[1] ? '' : (row['Option 2'] || row['option_2'] || ''),
                        optionImages[2] ? '' : (row['Option 3'] || row['option_3'] || ''),
                        optionImages[3] ? '' : (row['Option 4'] || row['option_4'] || '')
                    ];
                    
                    let correctAnswer = row['Correct Answer'] || row['correct_answer'] || '';
                    correctAnswer = normalizeCorrectAnswer(correctAnswer);
                    
                    return {
                        question_text: row['Question Text'] || row['question_text'] || '',
                        question_type: (row['Diagram URL'] || row['diagram']) ? 'diagram' : 'text',
                        diagram: row['Diagram URL'] || row['diagram'] || '',
                        options: options,
                        option_images: optionImages,
                        correct_answer: correctAnswer,
                        explanation: row['Explanation'] || row['explanation'] || '',
                        subject: row['Subject'] || row['subject'] || null
                    };
                });
                const hasSubjectsInExcel = questions.some(q => q.subject);

                if (hasSubjectsInExcel) {
                    const subjectCounts = {};
                    questions.forEach(q => {
                        if (q.subject) {
                            subjectCounts[q.subject] = (subjectCounts[q.subject] || 0) + 1;
                        }
                    });

                    const autoGeneratedSubjects = Object.keys(subjectCounts).map(subjectName => ({
                        subject_name: subjectName,
                        question_count: subjectCounts[subjectName]
                    }));

                    updatedTests[testIndex].has_subjects = true;
                    updatedTests[testIndex].subjects = autoGeneratedSubjects;

                    const summary = autoGeneratedSubjects.map(s => 
                        `  • ${s.subject_name}: ${s.question_count} questions`
                    ).join('\n');
                    
                    alert(`Subjects auto-detected from Excel:\n\n${summary}\n\nTotal: ${questions.length} questions`);
                } else {
                    updatedTests[testIndex].has_subjects = false;
                    updatedTests[testIndex].subjects = [];
                    alert(`No subjects found in Excel. Uploading ${questions.length} questions without subject classification.`);
                }

                updatedTests[testIndex].questions = [
                    ...(updatedTests[testIndex].questions || []),
                    ...questions
                ];
                
                handlechange({ target: { name: 'tests', value: updatedTests }});
                
                e.target.value = '';
            } catch (error) {
                console.error('Error parsing Excel file:', error);
                alert('Error parsing Excel file. Please check the format and try again.');
            }
        };
        reader.readAsBinaryString(file);
    };

    return (
        <>
            <Dialog header="Test Series Form" visible={visible} onHide={() => { if (!visible) return; setVisible(false); }} style={{ width: "90vw" }} 
                breakpoints={{ "960px": "95vw", "641px": "100vw" }} maximizable maximized={maximized} onMaximize={(e) => setMaximized(e.maximized)}
            >
                
                <form onSubmit={!formdata._id ? handlesave : handleupdate}>
                    <div className="p-4 mb-4 bg-gray-50 rounded-xl">
                        <h3 className="mb-3 text-lg font-semibold">Package Details</h3>
                        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 lg:grid-cols-4">
                            <div>
                                <label className="font-medium">Test Series Name</label>
                                <input type="text" name="Test_name" value={formdata["Test_name"] || ''}  className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                    onChange={handlechange} required />
                            </div>
                            <div>
                                <label className="font-medium">Price</label>
                                <input type="number" name="Price" value={formdata["Price"] || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                    onChange={handlechange} required 
                                />
                            </div>
                            <div>
                                <label className="font-medium">Discount (%)</label>
                                <input type="number" name="Discount" value={formdata["Discount"] || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                    onChange={handlechange} required 
                                />
                            </div>
                            <div>
                                <label className="font-medium">Sale Price</label>
                                <input type="number" name="Sale_Price" value={formdata["Sale_Price"] || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" readOnly/>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-5 mt-4">
                            <div className="">
                                <label className="font-medium">Description</label>
                                <ReactQuill theme="snow" value={formdata['Description'] || ''} onChange={handleQuillChange} className="mt-1 bg-white rounded-xl" />
                            </div>
                            <div>
                                <label className="font-medium">Status</label>
                                <select name="Status" value={formdata["Status"] || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                    onChange={handlechange} required 
                                >
                                    <option value="">--- Select status ---</option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="p-4 mb-4 bg-blue-50 rounded-xl">
                        <div className="flex items-center justify-between mb-3">
                            <h3 className="text-lg font-semibold">Tests in Package</h3>
                            <button type="button" onClick={addTest} className="px-3 py-1 text-white rounded-lg bg-regal-yellow">Add Test</button>
                        </div>

                        {formdata.tests && formdata.tests.length > 0 ? (
                            <Accordion multiple>
                                {formdata.tests.map((test, testIndex) => (
                                    <AccordionTab key={testIndex} 
                                        header={
                                            <div className="flex items-center justify-between w-full">
                                                <span>{test.test_name || `Test ${testIndex + 1}`}</span>
                                                <button  onClick={(e) => { removeTest(testIndex);}} className="px-4 py-1 text-white bg-red-500 rounded-lg"><X/></button>
                                            </div>
                                        }
                                    >
                                        <div className="p-4 mb-4 bg-white rounded-xl">
                                            <h4 className="mb-3 font-semibold">Test Configuration</h4>
                                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                                                <div>
                                                    <label className="font-medium">Test Name</label>
                                                    <input type="text" value={test.test_name || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                                        onChange={(e) => updateTest(testIndex, 'test_name', e.target.value)} required 
                                                    />
                                                </div>
                                                <div>
                                                    <label className="font-medium">Duration (minutes)</label>
                                                    <input type="number" value={test.duration || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                                        onChange={(e) => updateTest(testIndex, 'duration', parseInt(e.target.value))} required 
                                                    />
                                                </div>
                                                <div>
                                                    <label className="font-medium">Total Marks</label>
                                                    <input type="number" value={test.total_marks || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                                        onChange={(e) => updateTest(testIndex, 'total_marks', parseInt(e.target.value))} required 
                                                    />
                                                </div>
                                                <div>
                                                    <label className="font-medium">Marks per Question</label>
                                                    <input type="number" value={test.marks_per_question || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                                        onChange={(e) => updateTest(testIndex, 'marks_per_question', parseInt(e.target.value))}required 
                                                    />
                                                </div>
                                                <div>
                                                    <label className="font-medium">Negative Marks</label>
                                                    <input type="number" value={test.negative_marks || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                                        onChange={(e) => updateTest(testIndex, 'negative_marks', parseFloat(e.target.value))} 
                                                    />
                                                </div>
                                                <div className="flex items-center gap-2 mt-6">
                                                    <InputSwitch checked={test.negative_marking === true} onChange={(e) => updateTest(testIndex, 'negative_marking', e.value)} />
                                                    <label className="font-medium">Enable Negative Marking</label>
                                                </div>
                                                <div className="flex items-center gap-2 mt-6">
                                                    <InputSwitch checked={test.has_subjects || false} onChange={(e) => updateTest(testIndex, 'has_subjects', e.value)} />
                                                    <label className="font-medium">Has Subject-wise Questions</label>
                                                </div>
                                            </div>
                                        </div>

                                        {test.has_subjects && (
                                            <div className="p-4 mb-4 bg-green-50 rounded-xl">
                                                <div className="flex items-center justify-between mb-3">
                                                    <h4 className="font-semibold">Subjects</h4>
                                                    <Button type="button" label="Add Subject" icon="pi pi-plus" onClick={() => addSubject(testIndex)} className="p-button-sm p-button-success"/>
                                                </div>
                                                {test.subjects && test.subjects.map((subject, subjectIndex) => (
                                                    <div key={subjectIndex} className="flex gap-3 p-3 mb-2 bg-white rounded-xl">
                                                        <div className="flex-1">
                                                            <label className="text-sm font-medium">Subject Name</label>
                                                            <input type="text" value={subject.subject_name || ''} className="w-full px-3 py-2 mt-1 border outline-none rounded-xl" 
                                                                onChange={(e) => updateSubject(testIndex, subjectIndex, 'subject_name', e.target.value)} 
                                                                placeholder="e.g., Physics, Chemistry"
                                                            />
                                                        </div>
                                                        <div className="flex-1">
                                                            <label className="text-sm font-medium">Question Count</label>
                                                            <input type="number" value={subject.question_count || 0} className="w-full px-3 py-2 mt-1 border outline-none rounded-xl" 
                                                                onChange={(e) => updateSubject(testIndex, subjectIndex, 'question_count', parseInt(e.target.value))}
                                                            />
                                                        </div>
                                                        <div className="flex items-end">
                                                            <button type="submit" onClick={() => removeSubject(testIndex, subjectIndex)} className="px-4 py-1 text-white bg-red-500 rounded-xl"><X/></button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        <div className="p-4 bg-yellow-50 rounded-xl">
                                            <div className="flex flex-col gap-3 mb-3 sm:flex-row sm:items-center sm:justify-end">
                                                <div className="flex flex-wrap gap-2">
                                                   <ExcelTemplate/>
                                                    <label className="px-3 py-1 text-xs text-white bg-blue-600 rounded-lg cursor-pointer hover:bg-blue-700">
                                                        <Upload/>
                                                        <input type="file" accept=".xlsx, .xls" onChange={(e) => handleBulkUpload(e, testIndex)}className="hidden" title="Bulk Upload"/>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="flex items-center justify-between mb-3">
                                                <h4 className="font-semibold">Questions</h4>
                                                <button type="button" className="px-4 py-1 rounded-lg bg-regal-yellow"  onClick={() => addQuestion(testIndex)}>Add Question</button>
                                            </div>
                                            {test.questions && test.questions.map((question, questionIndex) => (
                                                <div key={questionIndex} className="p-4 mb-3 bg-white rounded-xl">
                                                    <div className="flex items-center justify-between mb-3">
                                                        <h5 className="font-semibold">Question {questionIndex + 1}</h5>
                                                        <button onClick={() => removeQuestion(testIndex, questionIndex)} className="flex items-center justify-center w-8 h-8 text-white bg-red-500 rounded-full"><X/></button>
                                                    </div>
                                                    
                                                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                                        {test.has_subjects && (
                                                            <div>
                                                                <label className="text-sm font-medium">Subject</label>
                                                                <select value={question.subject || ''} className="w-full px-3 py-2 mt-1 border outline-none rounded-xl"
                                                                    onChange={(e) => updateQuestion(testIndex, questionIndex, 'subject', e.target.value)}
                                                                >
                                                                    <option value="">Select Subject</option>
                                                                    {test.subjects && test.subjects.map((sub, idx) => (
                                                                        <option key={idx} value={sub.subject_name}>
                                                                            {sub.subject_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        )}
                                                        <div>
                                                            <label className="text-sm font-medium">Question Type</label>
                                                            <select value={question.question_type || 'text'} className="w-full px-3 py-2 mt-1 border outline-none rounded-xl"
                                                                onChange={(e) => updateQuestion(testIndex, questionIndex, 'question_type', e.target.value)}
                                                            >
                                                                <option value="text">Text Only</option>
                                                                <option value="diagram">With Diagram</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="mt-3">
                                                        <label className="text-sm font-medium">Question Text</label>
                                                        <textarea
                                                            value={question.question_text || ''}
                                                            className="w-full px-3 py-2 mt-1 border outline-none rounded-xl"
                                                            rows="3"
                                                            onChange={(e) => updateQuestion(testIndex, questionIndex, 'question_text', e.target.value)}
                                                            placeholder="Enter question text"
                                                        />
                                                    </div>

                                                  {question.question_type === 'diagram' && (
                                                        <div className="mt-3">
                                                            <label className="text-sm font-medium">Diagram Image</label>
                                                            <div className="flex items-center gap-3">
                                                                <input type="file" accept="image/*" className="w-full px-3 py-2 mt-1 border outline-none rounded-xl"
                                                                    onChange={(e) => handleDiagramChange(e, testIndex, questionIndex)}
                                                                />
                                                                {question.diagram && (
                                                                    <button type="button" onClick={() => removeDiagram(testIndex, questionIndex)} className="px-3 py-2 mt-1 text-white bg-red-500 rounded-lg hover:bg-red-600">
                                                                        Remove
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {question.diagram && (
                                                                <div className="mt-2">
                                                                    <p className="text-sm text-gray-600">
                                                                        Selected: {typeof question.diagram === 'string' ? 'Existing image' : question.diagram.name}
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}

                                                <div className="grid grid-cols-1 gap-2 mt-3 md:grid-cols-2">
                                                    {question.options && question.options.map((option, optionIndex) => (
                                                        <div key={optionIndex} className="p-3 border rounded-lg">
                                                            <label className="text-sm font-medium">Option {optionIndex + 1}</label>
                                                            
                                                            {(!question.option_images || !question.option_images[optionIndex]) && (
                                                                <input 
                                                                    type="text" 
                                                                    value={option || ''} 
                                                                    className="w-full px-3 py-2 mt-1 border outline-none rounded-xl"
                                                                    onChange={(e) => updateQuestionOption(testIndex, questionIndex, optionIndex, e.target.value)}
                                                                    placeholder={`Option ${optionIndex + 1} text`}
                                                                />
                                                            )}
                                                            
                                                            <div className="mt-2">
                                                                <label className="text-xs font-medium text-gray-600">
                                                                    {question.option_images && question.option_images[optionIndex] ? 'Option Image' : 'Upload Image (or use text above)'}
                                                                </label>
                                                                <div className="flex items-center gap-2 mt-1">
                                                                    <input 
                                                                        type="file" 
                                                                        accept="image/*" 
                                                                        className="flex-1 text-sm"
                                                                        onChange={(e) => handleOptionImageChange(e, testIndex, questionIndex, optionIndex)}
                                                                    />
                                                                    {question.option_images && question.option_images[optionIndex] && (
                                                                        <button 
                                                                            type="button" 
                                                                            onClick={() => removeOptionImage(testIndex, questionIndex, optionIndex)} 
                                                                            className="px-2 py-1 text-xs text-white bg-red-500 rounded hover:bg-red-600"
                                                                        >
                                                                            Remove
                                                                        </button>
                                                                    )}
                                                                </div>
                                                                {question.option_images && question.option_images[optionIndex] && (
                                                                    <div className="p-2 mt-2 rounded-lg bg-gray-50">
                                                                       
                                                                        <p className="text-xs text-gray-600">
                                                                            {typeof question.option_images[optionIndex] === 'string' ? 'Existing image' : question.option_images[optionIndex].name}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                                    <div className="grid grid-cols-1 gap-3 mt-3 md:grid-cols-2">
                                                        <div>
                                                            <label className="text-sm font-medium">Correct Answer</label>
                                                            <select
                                                                value={question.correct_answer || ''}
                                                                className="w-full px-3 py-2 mt-1 border outline-none rounded-xl"
                                                                onChange={(e) => updateQuestion(testIndex, questionIndex, 'correct_answer', e.target.value)}
                                                            >
                                                                <option value="">Select Correct Answer</option>
                                                                {question.options && question.options.map((opt, idx) => {
                                                                    const hasImage = question.option_images && question.option_images[idx];
                                                                    const optionValue = `option_${idx}`;
                                                                    const displayText = hasImage 
                                                                        ? `Option ${['A', 'B', 'C', 'D'][idx]}: [Image]` 
                                                                        : `Option ${['A', 'B', 'C', 'D'][idx]}: ${opt}`;
                                                                    return (
                                                                        <option key={idx} value={optionValue}>
                                                                            {displayText}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label className="text-sm font-medium">Explanation</label>
                                                            <textarea
                                                                value={question.explanation || ''}
                                                                className="w-full px-3 py-2 mt-1 border outline-none rounded-xl"
                                                                rows="2"
                                                                onChange={(e) => updateQuestion(testIndex, questionIndex, 'explanation', e.target.value)}
                                                                placeholder="Explanation for the answer"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </AccordionTab>
                                ))}
                            </Accordion>
                        ) : (
                            <p className="text-center text-gray-500">No tests added yet. Click "Add Test" to create one.</p>
                        )}
                    </div>

                    <div className="fixed bottom-0 flex justify-end w-full gap-3 p-5 mt-5 bg-white right-10">
                        <button type="button" onClick={() => setVisible(false)} className="px-4 py-1 bg-gray-200 rounded-lg">Cancel</button>
                        <button type="submit" className="px-4 py-1 text-white rounded-lg bg-regal-blue">{!formdata._id ? "Save" : "Update"}</button>
                    </div>
                </form>
            </Dialog>
        </>
    );
}